import { SettingsRow } from '@reflex/ui/components/shared/SettingsRow';
import { Switch } from '@reflex/ui/components/ui/switch';
import { Badge } from '@reflex/ui/components/ui/badge';
import { Label } from '@reflex/ui/components/ui/label';
import { useSetAgentTypeEnabled } from '@/hooks/config/useAgentModelPolicy';
import type { AdminLaunchableAgentEntry } from '@reflex/shared';
import type { PolicyScope } from './AgentPolicyCardHeader';

export interface SingleModelAgentCardProps {
  agent: AdminLaunchableAgentEntry;
  scope: PolicyScope;
  readOnly?: boolean;
}

export function SingleModelAgentCard({
  agent,
  scope,
  readOnly = false,
}: SingleModelAgentCardProps) {
  const toggleAgentEnabled = useSetAgentTypeEnabled();

  return (
    <SettingsRow
      title={agent.displayName}
      badges={
        <>
          {!agent.effectiveEnabled && (
            <Badge variant="destructive" className="text-2xs">
              disabled
            </Badge>
          )}
          <Badge variant="outline" className="text-2xs">
            single-model
          </Badge>
        </>
      }
      control={
        <>
          <Label className="text-xs text-muted-foreground max-sm:sr-only">Available</Label>
          <Switch
            checked={agent.effectiveEnabled}
            onCheckedChange={(checked) => {
              if (readOnly) return;
              toggleAgentEnabled.mutate({
                agentType: agent.agentType,
                enabled: checked,
                scope,
              });
            }}
            disabled={readOnly || toggleAgentEnabled.isPending}
            aria-label={`Toggle ${agent.displayName} availability`}
          />
        </>
      }
    />
  );
}
